export default __webpack_public_path__ + "static/media/gwn26.1623126e.webp";